/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *==================================================
 */
//standard libraries
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";

//custom libraries
import * as ROUTES from "./constants/routes";
import { LoadingBackDrop, MessageSnackbar } from "./containers";
import { useCSRValue } from "./context";
import AuthProtectedRoute from "./helpers/authProtectedRoute";
import { Customer, Dashboard, Order } from "./pages";

import "./assets/style.css";
import AdminProtectedRoute from "./helpers/adminProtectedRoute";
import InventoryPage from "./pages/inventory";
import ExpiredSessionModal from "./components/expired-session-modal";

const App = () => {
  const { csr } = useCSRValue();
  const { t } = useTranslation();
  const baseName = process.env.REACT_APP_ROUTER_BASENAME
    ? { basename: process.env.REACT_APP_ROUTER_BASENAME }
    : {};

  return (
    <Router {...baseName}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{t("Header.CustomerServiceHub")}</title>
      </Helmet>
      <ExpiredSessionModal />
      <MessageSnackbar />
      <LoadingBackDrop />
      <Switch>
        <AuthProtectedRoute user={csr} path={ROUTES.CUSTOMER}>
          <Customer />
        </AuthProtectedRoute>

        <AuthProtectedRoute user={csr} path={ROUTES.ORDER}>
          <Order />
        </AuthProtectedRoute>

        <AdminProtectedRoute user={csr} path={ROUTES.INVENTORY}>
          <InventoryPage />
        </AdminProtectedRoute>

        <Route exact path={ROUTES.DASHBOARD}>
          {(!csr || !csr.userLoggedIn) && <Dashboard />}
          {csr && csr.userLoggedIn && (
            <Redirect
              to={{
                pathname: ROUTES.ORDER,
                state: { from: ROUTES.DASHBOARD },
              }}
            />
          )}
        </Route>

        <Route exact path="/*">
          <Redirect to={ROUTES.DASHBOARD} />
        </Route>
      </Switch>
    </Router>
  );
};

export default App;
